module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "pt1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "PN"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_13",
      "title": "13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#p_pt1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Laceleaf")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-No-Indent-potx1"
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("DESCRIPTION:")]), _vm._v(" Attractive wide-ranging plant with delicate green leaves and clumps of small white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("SYMPTOMS:")]), _vm._v(" Dilated pupils, rapid weak pulse, and a peripheral numbness that spreads inward, resulting in respiratory paralysis and heart failure.")]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("PROOFING CUES:")]), _vm._v(" Mild, musty smell and pleasant flavor, often mistaken for harmless cousins.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-726f9926","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 75
// module chunks = 0